export default __webpack_public_path__ + "static/media/add-but.ef08c10b.svg";